var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60223 11.3096C4.80105 11.5029 5.12339 11.5029 5.3222 11.3096L9.39493 7.35C9.4904 7.25717 9.54403 7.13128 9.54403 7.00001C9.54403 6.86875 9.4904 6.74285 9.39493 6.65003L5.3222 2.69044C5.12339 2.49714 4.80105 2.49714 4.60224 2.69044C4.40342 2.88372 4.40342 3.19711 4.60224 3.3904L8.31498 7.00001L4.60223 10.6096C4.40342 10.8029 4.40342 11.1163 4.60223 11.3096Z",
    fill: "#0C0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon2);
export default __webpack_public_path__ + "static/media/toggle-icon-2.18e7557f1e067b699c326820ff30722c.svg";
export { ForwardRef as ReactComponent };